import React, { useEffect } from 'react';
import { Flex, Image, VStack } from '@chakra-ui/react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const InitPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // ログイン済みの場合は自動的にメイン画面へ遷移
    if (!isLoading && isAuthenticated) {
      navigate('/main/home', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <Flex justify="center" align="center" h="100vh" w="full">
      <VStack w="80%">
        <Image src="/img/BunPay-logo-sample2.png" alt="main logo" w="full" maxW="300px" />
        <Flex justify="center" align="center" w="80%" maxW="280px">
          <VStack gap={4} w="full">
            <Button colorPalette="teal" size="lg" w="full" onClick={() => navigate('/login')}>
              ログイン
            </Button>
            <Button
              colorPalette="yellow"
              variant="surface"
              size="lg"
              w="full"
              onClick={() => navigate('/create-account')}
            >
              アカウント作成
            </Button>
          </VStack>
        </Flex>
      </VStack>
    </Flex>
  );
};

export default InitPage;
